// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core--app-bar.MuiPaper-elevation4{box-shadow:none}`, "",{"version":3,"sources":["webpack://./src/common-client2/src/components/AppBar/AppBar.scss"],"names":[],"mappings":"AAEI,mCACI,eAAA","sourcesContent":["\r\n.core--app-bar {\r\n    &.MuiPaper-elevation4 {\r\n        box-shadow: none;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
